export interface AuthResponse {  
  token?: string;
  playerId?: string;  
}

export interface UserData {
  id: string;
  token: string;
  balance: Money | undefined;
  username: string;
}

export interface Money {
  amount: string;
  currency: string;
}

export type TerminalMode = "buy" | "coupons" | "display";

export const getIframeUrl = (user: UserData, mode: TerminalMode) => {
  const baseUrl = `${process.env["REACT_APP_GAME_URL"]}`; // Replace with actual betting platform URL
  
  let navigationKey = "terminalagent";
  if (mode === "coupons") {
    navigationKey = "terminalcouponagent";
  } else if (mode === "display") {
    navigationKey = "terminaldisplay";
  }
  
  const params = new URLSearchParams({
    operatorId: "MOCKOP",
    operatorPlayerId: user?.id || "0",
    operatorToken: user?.token || "",
    lang: "sv",
    theme: "dbet",
    navigationKey: navigationKey,
    navigationId: "12",
    operatorChannel: "offline"
  });
  return `${baseUrl}?${params.toString()}`;
};

